import { gql } from '@apollo/client';
import paginated from '../client/pagination';
import { createStringVariables } from './utils';
export const BENEFIT_SCHEDULE_FIELDS = `
annual_limit
benefit_categories
benefit_items
id
lifetime_limit
product
smm_annual_limit
`;
const FIELDS = `
  id
  short_code
  subtype_code
  unique_code
  code
  category
  benefit_schedule
  name
  name_zh
  name_en
  remark
  remark_zh
  remark_en
  is_fully_covered
  is_claimable
  is_reimbursement
  adjustment_factor
  smm_adjustment_factor
  dependent_item
  limits
  sequence
  category
  type
  remarks
  specialties
  specialty_mappings
`;
const listBenefitItemVariables = createStringVariables(['product_code', 'benefit_schedule_id', 'benefit_category_id', 'benefit_item_id', 'code', 'outpatient', 'is_claimable', 'ordering']);
export const LIST_BENEFIT_ITEMS = paginated(gql`
  query BenefitItem(${listBenefitItemVariables.variableTypes}) {
    benefitItem(
      ${listBenefitItemVariables.variables}
    )
      @rest(
        type: "BenefitItem"
        path: "/benefit/item?{args}"
        method: "GET"
      ) {
      __typename
      ${FIELDS}
    }
  }
`);